import {useRouter} from 'next/router'

/**
 * Determines if the current SRP is a SEO page by checking for the `taxonomy` query parameter.
 * example: /p/47319/en/the-netherlands/amsterdam
 */
export const useIsSeoSRP = () => {
  const {query} = useRouter()

  return Boolean(query?.taxonomy)
}
